import { motion } from "framer-motion";

const Footer = ({serviceName}) => {
	return (
		<footer className="relative z-10 py-12 bg-black text-center border-t border-white/10">
			<div className="max-w-7xl mx-auto px-4">
				<div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-left">
					<div>
						<h4 className="text-lg font-semibold mb-4 text-white">{serviceName}</h4>
						<p className="text-gray-400 text-sm">
							Передовая система защиты и ускорения веб-сайтов с искусственным интеллектом
						</p>
					</div>

					<div>
						<h4 className="text-lg font-semibold mb-4 text-white">Продукт</h4>
						<ul className="space-y-2 text-sm text-gray-400">
							<li><a href="/features" className="hover:text-white transition-colors">Возможности</a></li>
							<li><a href="/pricing" className="hover:text-white transition-colors">Тарифы</a></li>
							<li><a href="/docs" className="hover:text-white transition-colors">Документация</a></li>
						</ul>
					</div>

					<div>
						<h4 className="text-lg font-semibold mb-4 text-white">Поддержка</h4>
						<ul className="space-y-2 text-sm text-gray-400">
							<li><a href="/help" className="hover:text-white transition-colors">Помощь</a></li>
							<li><a href="/contacts" className="hover:text-white transition-colors">Контакты</a></li>
							<li><a href="/status" className="hover:text-white transition-colors">Статус системы</a></li>
						</ul>
					</div>

					<div>
						<h4 className="text-lg font-semibold mb-4 text-white">Контакты</h4>
						<ul className="space-y-2 text-sm text-gray-400">
							<li>Email: info@ai-cdn.ru</li>
							<li>Телефон: +7 (999) 123-45-67</li>
							<li>Техподдержка 24/7</li>
						</ul>
					</div>
				</div>

				<div className="border-t border-white/10 mt-8 pt-8 text-center">
					<p className="text-gray-500 text-sm">
						© 2025 {serviceName} System. Все права защищены.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
